import React, { Suspense } from "react";
import { Node_Type } from "./../../ricos-types/index.js";
import { CaptionLazy } from "../../_shared/figure/caption-renderer-lazy.js";
const Video = React.lazy(
  () => import(
    /* webpackChunkName: "ricos_plugin_video_lazy" */
    "./viewer-video.js"
  )
);
const VideoRenderer = ({
  node,
  nodeIndex,
  NodeViewContainer,
  ...props
}) => {
  return /* @__PURE__ */ React.createElement(Video, { node, nodeIndex, NodeViewContainer, ...props });
};
const VideoLazy = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(Suspense, { fallback: "" }, /* @__PURE__ */ React.createElement(VideoRenderer, { key: node.id, node, ...props }));
};
const nodeViewRenderers = {
  [Node_Type.VIDEO]: VideoLazy,
  [Node_Type.CAPTION]: CaptionLazy
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=node-view-renderers-lazy.js.map
